<div class="mech-diag-content">
	<app-dvs-chart [error]="errormessage" [options]="tsoptions"></app-dvs-chart>
	<app-dvs-chart [error]="errormessage" [options]="spectrumoptions"></app-dvs-chart>
	<div class="ordercheck">
		<label>
			<input [(ngModel)]="useorder" (ngModelChange)="UpdateChart()" type="checkbox">
			Display in orders
		</label>
	</div>
</div>